import { BaseDto } from '../../core';
import { INCOTERMS } from '../../shared';

export class BuyerShippingAddressListDto extends BaseDto<BuyerShippingAddressListDto> {
  // buyerId: number;
  incoterms: INCOTERMS;
  countryCode: string;
}
